// prettier-ignore
// eslint-disable-next-line no-useless-escape
const regexMail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const validateMail = value => (value && regexMail.test(value) ? undefined : 'Your email must be valid');

export default validateMail;
